import React from "react";

const Accolades = () => {
    return (
        <div>
            This is Accolades
        </div>
    );
};

export default Accolades;